/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)


import "core-js/stable";
import "regenerator-runtime/runtime";


//require.context('../images/', true, /\.(gif|jpg|png|svg|eot|ttf|woff|woff2)$/i)
//require.context('fonts/', true, /\.(eot|ttf|woff|woff2|otf)$/i);
	
import './application'

import "@fortawesome/fontawesome-free/js/all";

//import 'bootstrap'
//import 'bootstrap-datepicker'


//require("bootstrap")

window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');


require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")

require("jquery")


// Make jQuery available everywhere
global.$ = require('jquery'), require('jquery-ui')

require('bootstrap-datepicker/dist/js/bootstrap-datepicker')
//require('bootstrap-datepicker')

require("jquery-ui/ui/widget")
require("jquery-ui/ui/widgets/sortable")
require("packs/custom/paloma")
require("packs/custom/spinner")

import "stylesheets/fonts.scss";

import "stylesheets/custom-fonts.scss";
//@import "~bootstrap/scss/bootstrap";  
import 'bootstrap/dist/css/bootstrap.min.css';

import "stylesheets/bootmods.scss";

//import "stylesheets/bootstrap_custom.scss";

import "stylesheets/colors.scss";
import "stylesheets/bootstrap-datepicker.scss";

import '@fortawesome/fontawesome-free';


import "stylesheets/about.scss";
import "stylesheets/clickwrap.scss";


const getMetaValue = (name) => {
  const element = document.querySelector(`meta[name="${name}"]`)
  return element?.getAttribute('content')
}

import Dropzone from "dropzone";

Dropzone.autoDiscover = false;


window.jQuery = $;
window.$ = $;


console.log('Deckible is loaded.')


